import { WrapperProps } from './Button'
import { TooltipText } from '../../Step/types'

export function getBackground(props: WrapperProps): string {
  const { isActive, isDisabled, buttonColors } = props
  const { active, neutral, disabled } = buttonColors

  if (isDisabled) {
    return disabled
  }

  if (isActive) {
    return active
  }

  return neutral
}

export function getHoverBackground(props: WrapperProps): string {
  const { isActive, isDisabled, buttonColors } = props
  const { hover, active, disabled } = buttonColors

  if (isDisabled) {
    return disabled
  }

  if (isActive) {
    return active
  }

  return hover
}

export function getColor(props: WrapperProps): string {
  const { isDisabled, buttonColors } = props
  const { textColor, disabledTextColor } = buttonColors

  if (isDisabled) {
    return disabledTextColor
  }

  return textColor
}

export function getBorderColor(props: WrapperProps, isHover: boolean = false): string {
  const { isDisabled, buttonColors } = props
  const { borderColor, hoverBorderColor, disabledBorderColor } = buttonColors

  if (isDisabled) {
    return disabledBorderColor
  }

  if (isHover) {
    return hoverBorderColor || borderColor
  }

  return borderColor
}

export function getButtonTooltipText(error?: TooltipText, tooltipText?: TooltipText): TooltipText {
  if (error) {
    return error || 'Unknown error'
  }

  return tooltipText || ''
}
